export default __webpack_public_path__ + "static/media/full-switch.0da5a89e.svg";